import { useEffect } from "react";
import { useSnackbar } from "react-simple-snackbar";
import { snackbarErrorOptions } from "$utils/SnackbarOptions";

type SnackbarEventDetail = {
  message: string;
  duration?: number;
};

/**
 * Allows non-React code (eg. Axios interceptors) to trigger a snackbar by emitting:
 * `window.dispatchEvent(new CustomEvent("app:snackbar:error", { detail: { message, duration } }))`
 */
export function GlobalSnackbarListener() {
  const [openErrorSnackbar] = useSnackbar(snackbarErrorOptions);

  useEffect(() => {
    const handler = (event: Event) => {
      const customEvent = event as CustomEvent<SnackbarEventDetail>;
      const message = customEvent?.detail?.message;
      if (!message) return;
      openErrorSnackbar(message, customEvent?.detail?.duration);
    };

    window.addEventListener("app:snackbar:error", handler);
    return () => window.removeEventListener("app:snackbar:error", handler);
  }, [openErrorSnackbar]);

  return null;
}
